"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.backgroundSizeOptions = exports.backgroundRepeatOptions = exports.backgroundPositionOptions = void 0;

var _react = _interopRequireDefault(require("react"));

var _peractoEditorUi = require("@peracto/peracto-editor-ui");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var backgroundPositionOptions = [{
  label: 'Centre',
  value: 'center'
}, {
  label: 'Top',
  value: 'center top'
}, {
  label: 'Bottom',
  value: 'center bottom'
}, {
  label: 'Left',
  value: 'left center'
}, {
  label: 'Right',
  value: 'right center'
}];
exports.backgroundPositionOptions = backgroundPositionOptions;
var backgroundSizeOptions = [{
  label: 'Initial',
  value: 'initial'
}, {
  label: 'Cover',
  value: 'cover'
}, {
  label: 'Contain',
  value: 'contain'
}];
exports.backgroundSizeOptions = backgroundSizeOptions;
var backgroundRepeatOptions = [{
  label: 'None',
  value: 'no-repeat'
}, {
  label: 'Both',
  value: 'both'
}, {
  label: 'Horizontal',
  value: 'repeat-x'
}, {
  label: 'Vertical',
  value: 'repeat-y'
}];
exports.backgroundRepeatOptions = backgroundRepeatOptions;

var BackgroundImageOptions = function BackgroundImageOptions(_ref) {
  var _settings$backgroundI;

  var settings = _ref.settings,
      setSettings = _ref.setSettings,
      _ref$canContainBackgr = _ref.canContainBackground,
      canContainBackground = _ref$canContainBackgr === void 0 ? false : _ref$canContainBackgr;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "background-image-options-section"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between mt-2"
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Background Image Options")), /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.File, {
    label: "Image",
    value: settings.backgroundImage,
    showThumbnail: false,
    onChange: function onChange(value) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        backgroundImage: value
      }));
    },
    "data-testid": "background-image"
  }), (settings === null || settings === void 0 ? void 0 : (_settings$backgroundI = settings.backgroundImage) === null || _settings$backgroundI === void 0 ? void 0 : _settings$backgroundI.length) > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Select, {
    label: "Background Position",
    options: backgroundPositionOptions,
    value: settings.backgroundPosition,
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        backgroundPosition: value
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Select, {
    label: "Background Size",
    options: backgroundSizeOptions,
    value: settings.backgroundSize,
    onChange: function onChange(_ref3) {
      var value = _ref3.value;
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        backgroundSize: value
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Select, {
    label: "Background Repeat",
    options: backgroundRepeatOptions,
    value: settings.backgroundRepeat,
    onChange: function onChange(_ref4) {
      var value = _ref4.value;
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        backgroundRepeat: value
      }));
    }
  }), canContainBackground && /*#__PURE__*/_react["default"].createElement(_peractoEditorUi.Checkbox, {
    label: "Contain Background",
    checked: settings.backgroundContain,
    onChange: function onChange(e) {
      return setSettings(_objectSpread(_objectSpread({}, settings), {}, {
        backgroundContain: e.target.checked
      }));
    },
    help: "Limit the width of the background to the storefront page container's width"
  })));
};

var _default = BackgroundImageOptions;
exports["default"] = _default;